import { render, staticRenderFns } from "./OrganisationChat.vue?vue&type=template&id=7d872e50&scoped=true&"
import script from "./OrganisationChat.vue?vue&type=script&lang=js&"
export * from "./OrganisationChat.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationChat.vue?vue&type=style&index=0&id=7d872e50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d872e50",
  null
  
)

export default component.exports